/*
 * ob-buy-extras.js — complements du bloc d'achat (snippets/ob-buy-extras.liquid)
 * -------------------------------------------------------------------------
 * 1. Aide sous le bouton : le bouton « Ajouter au panier » est desactive tant
 *    qu'un bloc pose un verrou data-tt-block-* (le champ du compte, en
 *    pratique). La ligne d'aide s'affiche alors et ramene au champ.
 * 2. Mention de recurrence : simplement placee sous le bouton ; son texte est
 *    gere par ob-subscription.js.
 * 3. Delai de demarrage et option payante (voir plus bas).
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.obxInit === '1') return;
    root.dataset.obxInit = '1';

    var buy = root.closest('[data-tt-buy]');
    if (!buy) return;
    var form = buy.querySelector('form[action*="/cart/add"]');
    var btn = form && form.querySelector('[type="submit"], button[name="add"]');
    var hint = root.querySelector('[data-obx-hint]');
    var recur = root.querySelector('[data-ob-recur]');

    var eta = root.querySelector('[data-obx-eta]');

    // Lignes liees au bouton : sous le bloc d'achat rapide (PayPal, Shop Pay…)
    // quand il existe, pour ne pas separer les deux boutons ; sinon juste
    // sous « Ajouter au panier ».
    var express = form && form.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
    var anchor = express || btn;
    if (anchor && anchor.parentNode) {
      if (eta) anchor.insertAdjacentElement('afterend', eta);
      if (recur) anchor.insertAdjacentElement('afterend', recur);
      if (hint) anchor.insertAdjacentElement('afterend', hint);
    }

    // ---- Delai de demarrage -------------------------------------------------
    // Heure locale du visiteur + delai regle, arrondie a l'heure pleine
    // superieure : « demarrage avant aujourd'hui a 15 h ».
    function renderEta() {
      if (!eta) return;
      var hours = parseInt(eta.getAttribute('data-hours'), 10);
      if (!(hours > 0)) return;
      var lang = document.documentElement.lang || undefined;
      var now = new Date();
      var at = new Date(now.getTime() + hours * 3600000);
      if (at.getMinutes() || at.getSeconds()) { at.setHours(at.getHours() + 1, 0, 0, 0); }
      var time;
      try {
        time = /^fr/i.test(lang || '') ? at.getHours() + '\u00a0h'
          : new Intl.DateTimeFormat(lang, { hour: 'numeric' }).format(at);
      } catch (e) { time = at.getHours() + 'h'; }
      var startOf = function (d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(); };
      var days = Math.round((startOf(at) - startOf(now)) / 86400000);
      var when;
      if (days === 0) when = eta.getAttribute('data-tpl-today').replace('%T', time);
      else if (days === 1) when = eta.getAttribute('data-tpl-tomorrow').replace('%T', time);
      else {
        var date;
        try { date = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }).format(at); } catch (e) { date = at.toLocaleDateString(); }
        when = eta.getAttribute('data-tpl-date').replace('%D', date).replace('%T', time);
      }
      eta.textContent = eta.getAttribute('data-tpl').replace('%W', when);
      eta.hidden = false;
    }
    renderEta();
    if (eta) setInterval(renderEta, 60000);

    function accountRoot() {
      return document.querySelector('[data-account-lookup]');
    }

    function isBlocked() {
      if (!btn || !btn.disabled) return false;
      for (var i = 0; i < btn.attributes.length; i++) {
        if (btn.attributes[i].name.indexOf('data-tt-block-') === 0) return true;
      }
      return false;
    }

    function goToAccount() {
      var acc = accountRoot();
      if (!acc) return false;
      acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = acc.querySelector('[data-al-input]');
      if (input) {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }
      flash(acc);
      return true;
    }

    function flash(el) {
      el.classList.remove('obx-flash');
      // Relance l'animation meme si la classe vient d'etre posee.
      void el.offsetWidth;
      el.classList.add('obx-flash');
    }

    function syncHint() {
      if (hint) hint.hidden = !isBlocked() || !accountRoot();
    }

    if (hint) {
      hint.addEventListener('click', function () { goToAccount(); });
    }
    if (btn && 'MutationObserver' in window) {
      new MutationObserver(syncHint)
        .observe(btn, { attributes: true });
    }
    syncHint();

    // ---- Option payante ------------------------------------------------------
    // Cochee, l'option est ajoutee au panier juste avant le pack, avec les
    // memes proprietes (pseudo) pour que la commande soit facile a relier.
    // On intercepte l'envoi en capture, apres les verrous des autres blocs :
    // si le formulaire est bloque (pseudo manquant), on ne fait rien.
    // « Acheter maintenant » ne passe pas par ce formulaire : l'option n'y est
    // donc pas ajoutee.
    var bump = buy.querySelector('[data-obx-bump]');
    if (bump && form) {
      var bumpInput = bump.querySelector('[data-obx-bump-input]');
      var bumpBusy = false;
      var bumpPass = false;
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (bumpPass) { bumpPass = false; return; }
        if (!bumpInput || !bumpInput.checked || isBlocked() || e.defaultPrevented) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (bumpBusy) return;
        bumpBusy = true;
        var props = {};
        try {
          new FormData(form).forEach(function (v, k) {
            var m = /^properties\[(.+)\]$/.exec(k);
            if (m && typeof v === 'string' && v) props[m[1]] = v;
          });
        } catch (err) {}
        var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(bump.getAttribute('data-variant-id')), quantity: 1, properties: props }] })
        }).catch(function () {}).then(function () {
          bumpBusy = false;
          bumpPass = true;
          if (form.requestSubmit) form.requestSubmit(btn || undefined);
          else if (btn) btn.click();
        });
      }, true);
    }
  }

  function boot() {
    document.querySelectorAll('[data-obx]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
